module.exports = __webpack_public_path__ + "img/simulations.25239f03.svg";